import type { StytchError } from '@stytch/vanilla-js';
import { memo } from 'react';
import { BodySmallRegular, type SizableTextProps } from 'smoothie';

import TestStytchErrorMessage from '../../../test/pages/auth/StytchErrorMessage';
import { getStytchErrorMessage } from '../stytchHelpers';

interface ErrorMessageProps extends SizableTextProps {
    error?: StytchError;
}

const StytchErrorMessage = memo(({ error, ...props }: ErrorMessageProps) => {
    if (error == null) return null;

    const errorMessage = getStytchErrorMessage(error);

    if (errorMessage === undefined || errorMessage.trim() === '') {
        return null;
    }

    return (
        <BodySmallRegular
            color="$red1100"
            {...props}
            testID={TestStytchErrorMessage.errorMessageId}
        >
            {errorMessage}
        </BodySmallRegular>
    );
});

export default StytchErrorMessage;
